import React from 'react';

const RecommendedForYouWrapper = React.lazy(() =>
    import(/* webpackChunkName: "RecommendedForYouWrapper" */ './RecommendedForYouWrapper')
);

export function RecommendedForYouLoader(props) {
    return (
        <React.Suspense fallback={null}>
            <RecommendedForYouWrapper {...props} />
        </React.Suspense>
    );
}
